import { Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import Link from 'next/link';
import { Auth } from '@aws-amplify/auth';

import { authenticatedClient } from '@website/libs/graphql/apollo';
import { BackupPasswordDocument } from '@website/types/graphqlOperations';
import { LoaderButton, PasswordField } from '../../forms';

export default function ChangePassword({ userID }) {
  // Form initial values
  const initialValues = {
    oldPassword: '',
    newPassword: '',
  };

  // validator
  function validator(values) {
    const errors = {};

    // Check old password is set
    if (values.oldPassword === '') {
      errors.oldPassword = 'Required';
    }

    // Check new password meets security requirements
    const mediumRegex = new RegExp(
      '^(((?=.*[a-zA-Z])(?=.*[^a-zA-Z])))(?=.{6,})'
    );
    if (values.newPassword === '') {
      errors.newPassword = 'Required';
    } else if (values.newPassword.length < 6) {
      errors.newPassword = 'Password must be at least 6 characters.';
    } else if (!values.newPassword.match(mediumRegex)) {
      errors.newPassword =
        'Password must have both letters and a number or symbol.';
    }

    return errors;
  }

  // Return form
  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => validator(values)}
      onSubmit={async (values, formik) => {
        // Submit
        const user = await Auth.currentAuthenticatedUser();
        try {
          await Auth.changePassword(
            user,
            values.oldPassword,
            values.newPassword
          );
        } catch (e) {
          if (e.code === 'NotAuthorizedException') {
            formik.setFieldError('oldPassword', 'Old password was incorrect');
          } else {
            alert(e.message);
          }
          formik.setSubmitting(false);
          return;
        }

        // Backup the user password. Note we need to create a client here directly, as the <AppsyncClient> from _app.ts
        // won't have had it's state updated yet, so it will still be set as unauthenticated.
        const client = authenticatedClient(Auth, true);
        await client.mutate({
          mutation: BackupPasswordDocument,
          variables: { input: { password: values.password } },
        });

        alert('Password changed successfully');
      }}
    >
      {({ isSubmitting, isValidating }) => (
        <Form className="mt-3">
          <PasswordField name="oldPassword" title="Old Password" required />
          <PasswordField
            name="newPassword"
            title="New Password"
            required
            autoComplete="new-password"
          />
          <div className="d-grid gap-2">
            <LoaderButton isLoading={isSubmitting || isValidating} />
            <Link href="/me/[userID]" as={`/me/${userID}`} legacyBehavior>
              <Button variant="light">Cancel</Button>
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  );
}
